import React, { FunctionComponent, useCallback } from 'react';
import { Switch, Table, Typography } from 'antd';
import { useStore } from 'effector-react';
import moment from 'moment';
import { ColumnsType, TablePaginationConfig } from 'antd/lib/table';
import experiments, { getList } from '@stores/experiments';
import useTranslate from '@hooks/useTranslate';
import componentContent from './ExperimentsTable.content.json';

interface Experiment {
  name: string;
  domain: string;
  active: boolean;
  forAll: boolean;
  created: string;
  updated: string;
  coveragePercentage: number;
}

const ExperimentsTable: FunctionComponent = () => {
  const { list, preloaders, pagination } = useStore(experiments);
  const content = useTranslate(componentContent);

  const onChange = useCallback((pagination: TablePaginationConfig) => {
    getList({ pagination });
  }, []);

  const columns: ColumnsType<Experiment> = [
    {
      title: content.name,
      dataIndex: 'name',
      key: 'id',
      render: (name: string) => <Typography.Text>{name}</Typography.Text>,
    },
    {
      title: content.status,
      dataIndex: 'active',
      key: 'active',
      render: (active: boolean) => (
        <Switch
          checked={active}
          disabled
          style={{
            cursor: 'default',
            backgroundColor: active ? undefined : '#d9d9d9',
          }}
        />
      ),
    },
    {
      title: content.startDate,
      dataIndex: 'created',
      key: 'created',
      render: (created: string) => moment(created).format('YYYY-MM-DD HH:mm'),
    },
    {
      title: content.endDate,
      dataIndex: 'updated',
      key: 'updated',
      render: (updated: string) => moment(updated).format('YYYY-MM-DD HH:mm'),
    },
    {
      title: content.product,
      dataIndex: 'domain',
      key: 'domain',
    },
    {
      title: content.users,
      dataIndex: 'forAll',
      key: 'forAll',
      render: (forAll: boolean) => (
        <Switch
          checked={forAll}
          disabled
          style={{
            cursor: 'default',
            backgroundColor: forAll ? undefined : '#d9d9d9',
          }}
        />
      ),
    },
    {
      title: content.group,
      dataIndex: 'coveragePercentage',
      key: 'coveragePercentage',
      render: (val: number) => `${val.toFixed(2)}%`,
    },
  ];

  return (
    <div>
      <Table
        onChange={onChange}
        dataSource={list}
        columns={columns}
        rowKey='name'
        loading={!!preloaders.getList}
        pagination={{
          ...pagination,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50'],
          position: ['topRight', 'bottomRight'],
        }}
      />
    </div>
  );
};

export default ExperimentsTable;
